<script>
export default {
  name: "DataTableSimple",

  props: {
    headers: {
      type: Array,
      required: true,
      default: () => [],
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>

<template>
  <v-data-table
    :headers="headers"
    :items="items"
    v-bind="$attrs"
    mobile-breakpoint="768"
    hide-default-footer
  />
</template>

<style scoped lang="scss">
@import "../../scss/tableStyling";
</style>
